import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';

const useUnsavedChangeWarning = ( message="Want To Continue Without Saving Details?" ) => {

    const [isDirty, setIsDirty] = useState(false)

    useEffect(() => {
        window.onbeforeunload = isDirty && (() => message)

        return () => {
            window.onbeforeunload = null
        }
        // eslint-disable-next-line
    }, [isDirty])

    const routerPrompt = <Prompt when={isDirty} message={message} />

  return [routerPrompt, () => setIsDirty(true), () => setIsDirty(false)]
}

export default useUnsavedChangeWarning